import React from 'react'

import * as S from './styles'

import ecbrLogo from '../../../../assets/Icons/ecbrLogo.svg'
import history from '../../../../store/history'
import { Typography } from '../../../../components/Typography/styles'

import account from '../../../../assets/Icons/account.svg'
import useActions from '../../../../hooks/useActions'
import { loginActions } from '../../../../redux/ducks/login'
import { TooltipButton, TooltipMenu } from '../../../../components/Tooltip'
import { useSelector } from 'react-redux'
import LocalStorageService from '../../../../services/LocalStorageService'

const LoggedHeader = () => {
  const { isLogged } = useSelector((state) => state.login)
  const { logout } = useActions(loginActions)
  const user = LocalStorageService.get('user')

  const logoutHandler = async () => {
    await logout()
    history.push('/')
  }

  return (
    <S.Header>
      <S.Logo>
        <img src={ecbrLogo} alt="ecbrDNA" onClick={() => history.push('/')} />
      </S.Logo>

      {isLogged && (
        <TooltipMenu
          icon={
            <S.UserContainer>
              <S.UserImage>
                <img src={account} alt="account" />
              </S.UserImage>
              <Typography type="subTitle">
                {user ? user.name : 'Usuário'}
              </Typography>
            </S.UserContainer>
          }
          name="userOptions"
          closeOnClick
        >
          <TooltipButton text="Sair" onClick={logoutHandler} />
        </TooltipMenu>
      )}
    </S.Header>
  )
}

export default LoggedHeader
